import {createAction} from 'util/redux'

const NAMESPACE = 'CF_CHANGE_HANDLER/'

export const ensureGroupedCFMissingNullValuesAreFilledAction = createAction(NAMESPACE + 'ensureGroupedCFMissingNullValuesAreFilled')